import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterPanel = ({ 
  filters, 
  onFilterChange, 
  providers, 
  locations, 
  appointmentTypes 
}) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <div className="bg-card border-b border-border">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between px-4 md:px-6 py-4 text-foreground transition-smooth hover:bg-muted lg:hidden"
      >
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} />
          <span className="font-medium">Filters</span>
        </div>
        <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={20} />
      </button>
      <div className={`px-4 md:px-6 pb-4 space-y-4 ${isExpanded ? 'block' : 'hidden'} lg:block lg:py-4`}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <Select
            label="Provider"
            placeholder="All Providers"
            options={providers}
            value={filters?.provider}
            onChange={(value) => onFilterChange('provider', value)}
            searchable
          />

          <Select
            label="Location"
            placeholder="All Locations"
            options={locations}
            value={filters?.location}
            onChange={(value) => onFilterChange('location', value)}
          />

          <Select
            label="Appointment Type"
            placeholder="All Types"
            options={appointmentTypes}
            value={filters?.appointmentType}
            onChange={(value) => onFilterChange('appointmentType', value)}
          />

          <Input
            label="Search Patient"
            type="search"
            placeholder="Name or MRN"
            value={filters?.searchQuery}
            onChange={(e) => onFilterChange('searchQuery', e?.target?.value)}
          />
        </div>

        <div className="flex flex-wrap items-center gap-4 pt-2">
          <Checkbox
            label="Show only available slots"
            checked={filters?.showAvailableOnly}
            onChange={(e) => onFilterChange('showAvailableOnly', e?.target?.checked)}
          />
          <Checkbox
            label="Show cancelled appointments"
            checked={filters?.showCancelled}
            onChange={(e) => onFilterChange('showCancelled', e?.target?.checked)}
          />
          <Checkbox
            label="Show waitlist"
            checked={filters?.showWaitlist}
            onChange={(e) => onFilterChange('showWaitlist', e?.target?.checked)}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;